<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="row bg-white bottom-page-shadow rounded-bottom-extra mx-1">
    <div class="col pt-3 ">
      <p> <span class="fw-bold">Pembayar Cukai</span> - Penerimaan Pelantikan Ejen Cukai</p>


      <ul class="nav nav-pills nav-justified mb-3 tabs-bg shadow rounded py-2 ps-10 pe-10 mx-4" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button (click)="TabChange('Baharu')" class="nav-link" [ngClass]="NewStatus ? 'active' : ''" id="pills-belum-diproses-tab" data-bs-toggle="pill" data-bs-target="#pills-belum-diproses" type="button" role="tab" aria-controls="pills-belum-diproses" aria-selected="true">Belum Diproses</button>
        </li>
        <li class="nav-item" role="presentation">
          <button (click)="TabChange('Diluluskan')" class="nav-link" [ngClass]="ProcessedStatus ? 'active' : ''" id="pills-telah-diproses-tab" data-bs-toggle="pill" data-bs-target="#pills-telah-diproses" type="button" role="tab" aria-controls="pills-telah-diproses" aria-selected="false">Telah Diproses</button>
        </li>
        <li class="nav-item" role="presentation">
          <button (click)="TabChange('Ditolak')" class="nav-link" [ngClass]="RejectedStatus ? 'active' : ''" id="pills-telah-ditolak-dibatalkan-tab" data-bs-toggle="pill" data-bs-target="#pills-telah-ditolak-dibatalkan" type="button" role="tab" aria-controls="pills-telah-ditolak-dibatalkan" aria-selected="false">Ditolak / Dibatalkan</button>
        </li>
      </ul>
      <div class="tab-content mx-4 py-3" id="pills-tabContent">
        <div class="tab-pane fade" [ngClass]="NewStatus ? 'show active' : ''" id="pills-belum-diproses" role="tabpanel" aria-labelledby="pills-belum-diproses-tab" tabindex="0">

          <div class="row pt-2 py-4 ">
            <div class="col-2 d-flex justify-content-center align-items-center">
              <p>Kategori Carian : </p>
            </div>
            <div class="col-2 d-flex justify-content-center align-items-center">
              <select class="form-select" aria-label="Search type" [(ngModel)]="SearchTypeInput" [ngModelOptions]="{standalone: true}">
                <option value="" selected>Jenis Carian</option>
                <option value="1">MyKad/MyPR/MyKAS</option>
                <option value="2">No. Pasport/Dokumen lain</option>
                <!-- <option value="3">Tentera</option>
                <option value="4">Polis</option> -->
                <option value="5">No. Pendaftaran</option>
                <option value="6">TIN</option>
              </select>
            </div>
            <div class="col-1" [ngClass]="SearchTypeInput === '' ? 'd-none' : ''">
              <p>Carian : </p>
            </div>
            <div class="col-2" [ngClass]="SearchTypeInput === '' ? 'd-none' : ''">
              <input type="text" class="form-control" [(ngModel)]="ValueInput" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="btn-toolbar d-flex justify-content-end">
              <div class="me-2">
                <button type="button" class="btn submit-primary-button-sm border-0 shadow rounded-2" role="button" (click)="SubmitFilter(SearchTypeInput,ValueInput,'Baharu')">Hantar</button>
              </div>
              <div class="me-2">
                <button type="button" class="btn button-white-sm border-0 shadow rounded-2 bg-white" role="button" (click)="ClearFilter('Baharu')">Semula</button>
              </div>
            </div>
          </div>

          <table mat-table [dataSource]="dataSourceNew" class="w-100 shadow">
            <ng-container matColumnDef="taxpayername">
              <th class="text-center primary-colour rounded-top-left" mat-header-cell *matHeaderCellDef>Pembayar Cukai</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.taxPayerName}}</td>
            </ng-container>
            <ng-container matColumnDef="taxpayeridno">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>No. Pengenalan / No. Pendaftaran</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.itGrpCd != 'IG' ? res.busRegistNo : (res.newIcNo !== null ? res.newIcNo : (res.passportNo !== null ? res.passportNo : (res.policeArmyNo !== null ? res.policeArmyNo : 'N/A')))}}</td>
            </ng-container>
            <ng-container matColumnDef="taxpayertin">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>TIN</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.itrefNo}}</td>
            </ng-container>
            <ng-container matColumnDef="datereq">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Permohonan</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.requestDate}}</td>
            </ng-container>
            <ng-container matColumnDef="taxagent">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Ejen Cukai Dipilih</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.taxAgentName}}</td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th class="text-center primary-colour rounded-top-right" mat-header-cell *matHeaderCellDef>Tindakan</th>
              <td mat-cell *matCellDef="let res">
                <div class="btn-toolbar d-flex justify-content-center">
                  <div class="me-2">
                    <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="GotoDetailPage(res.lantikanId,'Baharu')">Papar</button>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let test;columns:displayedColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
            </tr>
          </table>
          <mat-paginator class="mat-evelation-z8" (page)="paginatorEvent($event,'Baharu')" [pageIndex]="pageNumNewGlobal" [pageSize]="pageSizeNewGlobal" [pageSizeOptions]="[10,15,20]" [length]="totalRecord">
          </mat-paginator>
        </div>
        <div class="tab-pane fade" [ngClass]="ProcessedStatus ? 'show active' : ''" id="pills-telah-diproses" role="tabpanel" aria-labelledby="pills-telah-diproses-tab" tabindex="0">

          <div class="row pt-2 py-4 ">
            <div class="col-2 d-flex justify-content-center align-items-center">
              <p>Kategori Carian : </p>
            </div>
            <div class="col-2 d-flex justify-content-center align-items-center">
              <select class="form-select" aria-label="Search type" [(ngModel)]="SearchTypeInput" [ngModelOptions]="{standalone: true}">
                <option value="" selected>Jenis Carian</option>
                <option value="1">MyKad/MyPR/MyKAS</option>
                <option value="2">No. Pasport/Dokumen lain</option>
                <!-- <option value="3">Tentera</option>
                <option value="4">Polis</option> -->
                <option value="5">No. Pendaftaran</option>
                <option value="6">TIN</option>
              </select>
            </div>
            <div class="col-1" [ngClass]="SearchTypeInput === '' ? 'd-none' : ''">
              <p>Carian : </p>
            </div>
            <div class="col-2" [ngClass]="SearchTypeInput === '' ? 'd-none' : ''">
              <input type="text" class="form-control" [(ngModel)]="ValueInput" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="btn-toolbar d-flex justify-content-end">
              <div class="me-2">
                <button type="button" class="btn submit-primary-button-sm border-0 shadow rounded-2" role="button" (click)="SubmitFilter(SearchTypeInput,ValueInput,'Diluluskan')">Hantar</button>
              </div>
              <div class="me-2">
                <button type="button" class="btn button-white-sm border-0 shadow rounded-2 bg-white" role="button" (click)="ClearFilter('Diluluskan')">Semula</button>
              </div>
            </div>
          </div>

          <table mat-table [dataSource]="dataSourceNew" class="w-100 shadow">
            <ng-container matColumnDef="taxpayername">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Pembayar Cukai</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.taxPayerName}}</td>
            </ng-container>
            <ng-container matColumnDef="taxpayeridno">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>No. Pengenalan / No. Pendaftaran</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.itGrpCd != 'IG' ? res.busRegistNo : (res.newIcNo !== null ? res.newIcNo : (res.passportNo !== null ? res.passportNo : (res.policeArmyNo !== null ? res.policeArmyNo : 'N/A')))}}</td>
            </ng-container>
            <ng-container matColumnDef="taxpayertin">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>TIN</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.itrefNo}}</td>
            </ng-container>
            <ng-container matColumnDef="datereq">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Permohonan</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.requestDate}}</td>
            </ng-container>
            <ng-container matColumnDef="taxagent">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Ejen Cukai Yang Dipilih</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.taxAgentName}}</td>
            </ng-container>

            <ng-container matColumnDef="approvedate">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Tindakan</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.actionDate}}</td>
            </ng-container>
            <ng-container matColumnDef="actionby">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan Oleh</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.actionName}}</td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
              <td mat-cell *matCellDef="let res">
                <div class="btn-toolbar d-flex justify-content-center">
                  <div class="me-2">
                    <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="GotoDetailPage(res.lantikanId,'Diluluskan')">Papar</button>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedProcessedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let test;columns:displayedProcessedColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
            </tr>
          </table>
          <mat-paginator class="mat-evelation-z8" (page)="paginatorEvent($event,'Diluluskan')" [pageIndex]="pageNumProcessedGlobal" [pageSize]="pageSizeProcessedGlobal" [pageSizeOptions]="[10,15,20]" [length]="totalRecord">
          </mat-paginator>
        </div>
        <div class="tab-pane fade" [ngClass]="RejectedStatus ? 'show active' : ''" id="pills-telah-ditolak-dibatalkan" role="tabpanel" aria-labelledby="pills-telah-ditolak-dibatalkan-tab" tabindex="0">

          <div class="row pt-2 py-4 ">
            <div class="col-2 d-flex justify-content-center align-items-center">
              <p>Kategori Carian : </p>
            </div>
            <div class="col-2 d-flex justify-content-center align-items-center">
              <select class="form-select " aria-label="Search type" [(ngModel)]="SearchTypeInput" [ngModelOptions]="{standalone: true}">
                <option value="" selected>Jenis Carian</option>
                <option value="1">MyKad/MyPR/MyKAS</option>
                <option value="2">No. Pasport/Dokumen lain</option>
                <!-- <option value="3">Tentera</option>
                <option value="4">Polis</option> -->
                <option value="5">No. Pendaftaran</option>
                <option value="6">TIN</option>
              </select>
            </div>
            <div class="col-1 " [ngClass]="SearchTypeInput === '' ? 'd-none' : ''">
              <p>Carian : </p>
            </div>
            <div class="col-2" [ngClass]="SearchTypeInput === '' ? 'd-none' : ''">
              <input type="text" class="form-control" [(ngModel)]="ValueInput" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="btn-toolbar d-flex justify-content-end">
              <div class="me-2">
                <button type="button" class="btn submit-primary-button-sm border-0 shadow rounded-2" role="button" (click)="SubmitFilter(SearchTypeInput,ValueInput,'Ditolak')">Hantar</button>
              </div>
              <div class="me-2">
                <button type="button" class="btn button-white-sm border-0 shadow rounded-2 bg-white" role="button" (click)="ClearFilter('Ditolak')">Semula</button>
              </div>
            </div>
          </div>

          <table mat-table [dataSource]="dataSourceNew" class="w-100 shadow">
            <ng-container matColumnDef="taxpayername">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Pembayar Cukai</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.taxPayerName}}</td>
            </ng-container>
            <ng-container matColumnDef="taxpayeridno">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>No. Pengenalan / No. Pendaftaran</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.itGrpCd != 'IG' ? res.busRegistNo : (res.newIcNo !== null ? res.newIcNo : (res.passportNo !== null ? res.passportNo : (res.policeArmyNo !== null ? res.policeArmyNo : 'N/A')))}}</td>
            </ng-container>
            <ng-container matColumnDef="taxpayertin">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>TIN</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.itrefNo}}</td>
            </ng-container>
            <ng-container matColumnDef="dateReq">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Permohonan</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.requestDate}}</td>
            </ng-container>
            <ng-container matColumnDef="taxagent">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Ejen Cukai Yang Dipilih</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.taxAgentName}}</td>
            </ng-container>
            <ng-container matColumnDef="approvedate">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Tindakan</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.status === 'Ditolak' ? res.actionDate : res.revokeDate}}</td>
            </ng-container>
            <ng-container matColumnDef="actionby">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan Oleh</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.status === 'Ditolak' ? res.actionName : res.revokeName}}</td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Status</th>
              <td class="text-center" mat-cell *matCellDef="let res">{{res.status}}</td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
              <td mat-cell *matCellDef="let res">
                <div class="btn-toolbar d-flex justify-content-center">
                  <div class="me-2">
                    <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="GotoDetailPage(res.lantikanId,'Ditolak')">Papar</button>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedRejectedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let test;columns:displayedRejectedColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center" colspan="10">Tiada Rekod</td>
            </tr>
          </table>
          <mat-paginator class="mat-evelation-z8" (page)="paginatorEvent($event,'Ditolak')" [pageIndex]="pageNumRejectedGlobal" [pageSize]="pageSizeRejectedGlobal" [pageSizeOptions]="[10,15,20]" [length]="totalRecord">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Kemaskini Modal -->
<div class="modal fade" id="agihSemulaModal" tabindex="-1" aria-labelledby="agihSemulaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Kemaskini</p>
          </div>
        </div>

        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <p class="text-muted fst-italic">Sila masukkan Nama, No. Pengenalan dan Kumpulan Pengguna</p>
          </div>
          <div class="btn-toolbar d-flex justify-content-center pb-5 pt-5">
            <div class="me-2">
              <button type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button">Agih Semula</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
